<template>
	<div>
		<div class="container">
			<keep-alive>
				<router-view></router-view>
			</keep-alive>
		</div>
		<div class="navbar">
			<div :class="['nav-item',isActive('/')?'active':'']" @click="jumpRole">

				<p style="font-size: 20px;">声音训练</p>
			</div>
			<div :class="['nav-item',isActive('/train')?'active':'']" @click="jumptrain">

				<p style="font-size: 20px;">声音合成</p>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'navbar',

		data() {
			return {

			};
		},
		activated() {},
		methods: {
			isActive(path) {
				// 判断当前路由是否激活，如果是则添加类名，否则不添加
				return this.$route.path === path
			},
			jumpRole() {
				this.$router.push("/");
			},
			jumptrain() {
				this.$router.push("/train");
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		top: 0;
		bottom: 17vw;
		left: 0;
		right: 0;
		position: absolute;
		overflow: hidden;
	}

	.navbar {
		display: flex;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 13.6vw;
		background-color: #ffffff;

		.nav-item {
			width: 50vw;
			display: flex;
			flex-direction: column;
			justify-content: space-evenly;
			align-items: center;
			text-align: center;
			filter: grayscale(100%);

			&.active {
				filter: none;

				p {
					color: #e5427b;
				}
			}

			img {
				width: 7vw;
				height: 7vw;
			}

			p {
				font-size: 2.5vw;
				margin: 0;
				color: gray;
			}
		}
	}
</style>